<!--
 * @Description  : 单项工程 几个工程tab 渲染
 * @Author       : 王帅
 * @Date         : 2024-08-24 17:15:38
 * @LastEditors  : 王帅
 * @LastEditTime : 2024-12-02 11:34:36
 * @FilePath     : \analysis_audit_admin\src\views\project-management\project-info\components\unit_fields.vue
-->
<template>
	<div class="w-page-main" :class="{ 'no-top': hideBtn }">
		<div class="w-page-header" v-if="!hideBtn">
			<div class="left-text"></div>
			<div class="btnGroups">
				<!-- 按钮 -->
				<el-button type="primary" size="small" class="ml10" @click="isDisabled = !isDisabled">{{ isDisabled ? '解锁' : '锁定' }}</el-button>
				<el-button type="success" size="small" v-if="!isDisabled" :loading="btnLoading" @click="doSave">保存</el-button>
			</div>
		</div>
		<div class="w-page-container overflow-y">
			<!-- 动态模板生成 -->
			<div class="baseForm-layout" v-for="(item, index) in pageList" :key="'模板' + index">
				<div class="baseForm-header overflow-hidden">{{ item.sname }}</div>
				<div class="baseForm-content">
					<el-form label-width="160px" size="large">
						<el-row>
							<el-col :span="24" v-for="(m, n) in item.fieldList" :key="'字段' + index + n">
								<el-form-item :label="m.title">
									<!-- formType标段类型 -->
									<!-- 1005001 数值型 -->
									<el-input
										v-if="m.formType === '1005001'"
										v-model="m.value"
										type="number"
										placeholder="请输入"
										:disabled="isDisabled || m.isEditable === 0"
									>
										<template slot="append" v-if="m.additional.suffix && m.additional.suffix !== ''">
											<span>{{ m.additional.suffix }}</span>
										</template>
									</el-input>

									<!-- 1005002 文本型 -->
									<el-input
										v-if="m.formType === '1005002'"
										v-model="m.value"
										placeholder="请输入"
										:disabled="isDisabled || m.isEditable === 0"
									>
										<template slot="append" v-if="m.additional.suffix && m.additional.suffix !== ''">
											<span>{{ m.additional.suffix }}</span>
										</template>
									</el-input>

									<!-- 1005003 日期型 -->
									<el-date-picker
										v-if="m.formType === '1005003'"
										v-model="m.value"
										:disabled="isDisabled || m.isEditable === 0"
										:type="m.additional.dateType"
										format="yyyy 年 MM 月 dd 日"
										value-format="yyyy-MM-dd"
										placeholder="请选择日期"
									>
									</el-date-picker>

									<!-- 1005004 文件型 -->
									<el-input v-if="m.formType === '1005004'" v-model="m.value" :disabled="isDisabled || m.isEditable === 0"></el-input>

									<!-- 1005005 文本（textarea） -->
									<el-input
										v-if="m.formType === '1005005'"
										type="textarea"
										:autosize="{ minRows: 2 }"
										:disabled="isDisabled || m.isEditable === 0"
										placeholder="请输入内容"
										v-model="m.value"
									>
									</el-input>

									<!-- 1005006 下拉选择型 -->
									<el-select
										v-if="m.formType === '1005006'"
										v-model="m.value"
										:disabled="isDisabled || m.isEditable === 0"
										placeholder="请选择"
									>
										<el-option
											v-for="(item, index) in m.additional.options"
											:key="item.value + index"
											:label="item.value"
											:value="item.value"
										>
										</el-option>
									</el-select>
									<!-- <el-select
										v-if="m.fieldId === '1263005747355123714'"
										v-model="m.infoValue"
										:disabled="isDisabled || m.isEditable === 0"
										@change="handleChangeMonth($event, m)"
										style="width: 47%"
										placeholder="请选择"
									>
										<el-option
											v-for="(item, index) in m.additional.options"
											:key="item.value + index"
											:label="item.value"
											:value="item.value"
										>
										</el-option>
									</el-select>
									<span v-if="m.fieldId === '1263005747355123714'" style="display: inline-block; width: 6%; text-align: center"
										>—</span
									>
									<el-date-picker
										v-if="m.fieldId === '1263005747355123714'"
										style="width: 47%"
										value-format="yyyy-MM"
										type="month"
										:disabled="isDisabled || m.isEditable === 0"
										@change="handleChangeMonth($event, m)"
										v-model="m.infoMonth"
										placeholder="选择年月"
									>
									</el-date-picker> -->

									<!-- 1005007 系统码表型 -->
									<el-select
										v-if="m.formType === '1005007'"
										v-model="m.value"
										:disabled="isDisabled || m.isEditable === 0"
										placeholder="请选择"
									>
										<el-option
											v-for="(item, index) in m.options"
											:key="item.value + index"
											:label="item.sname"
											:value="item.value"
										>
										</el-option>
									</el-select>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { saveProFieldsAndValue } from '@/api/modules/analysis'
export default {
	name: '',
	props: {
		templateList: {
			type: Array,
			default: () => {
				return []
			}
		},
		// 是否显示操作按钮
		hideBtn: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			isDisabled: true,
			btnLoading: false,
			pageList: []
		}
	},
	methods: {
		// 信息价依据 - 月份选择
		handleChangeMonth(val, obj) {
			obj.value = obj.infoValue + ',' + obj.infoMonth
		},

		// 点击保存
		doSave() {
			this.btnLoading = true
			let params = this.$utils.clone(this.pageList, true)
			saveProFieldsAndValue(params)
				.then((res) => {
					setTimeout(() => {
						this.btnLoading = false
					}, 2000)
					if (res.operationCode == 1) {
						// console.log(res.message)
						this.$message.success('保存成功!')
						this.isDisabled = true
						this.$emit('onSuccess')
					}
				})
				.catch((err) => {
					this.$message.error(err)
					setTimeout(() => {
						this.btnLoading = false
					}, 2000)
				})
		}
	},
	computed: {},
	watch: {
		templateList(arr) {
			this.pageList = this.$utils.clone(arr, true)
		}
	}
}
</script>
<style scoped lang="less">
.w-page-main.no-top {
	padding-top: 0;
}
</style>
